"use client";

import { faArrowUp } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { usePathname } from "next/navigation";
import { useMemo } from "react";
import { useBackToTopContext } from "~/app/[lang]/overlay/BackToTopContext";

export function BackToTop({ title }: { title: string }) {
	const pathname = usePathname();
	const { show } = useBackToTopContext();

	const element =
		typeof document !== "undefined"
			? (document.getElementById("start-ordering") ??
				document.getElementById("products") ??
				document.getElementById("main-content") ??
				document.getElementById("project-form"))
			: null;

	const renderButton = useMemo(() => {
		const excludedRoutes = ["cart", "order"];

		return !excludedRoutes.some((route) => pathname?.startsWith(`/${route}`));
	}, [pathname]);

	if (!(show && renderButton && element)) return null;

	return (
		<a
			href={`#${String(element.id)}`}
			className="flex items-center justify-center rounded-full bg-shades-light p-4 text-dark leading-none shadow hover:bg-shades focus-visible:bg-shades active:bg-shades motion-safe:transition sm:px-6"
		>
			<span className="flex aspect-square items-center justify-center sm:text-lg">
				<FontAwesomeIcon icon={faArrowUp} fixedWidth />
			</span>

			<span className="ml-2 hidden sm:inline">{title}</span>
		</a>
	);
}
